
<div style="margin: 10px; height: 344px" class="lm-border">
    <div style="margin: 15px">
        <v-row class="no-frame pa-1 "
               :class="favorite ? 'primary white--text' : 'black--text not-favorite'"
               style="font-size: 11pt; border-radius: 4px; width: calc(100% + 2px); "
               :style="favorite ? '' : 'border-width: 1px; border-style: solid;'"
        >
            <span class="pl-1">{{ calculation.unit.fabricNo  }}</span>
            <div style="font-size: 10px; padding-top: 6px">
                <span class="pl-1">{{ calculation.unit.street  }}, </span>
                <span class="pl-1">{{ calculation.unit.zip  }} {{ calculation.unit.city  }}</span>
            </div>
        </v-row>

        <inc-calculation
            :data     = "calculation"
            :form     = "form"
            :readonly = "readonly"
            :favorite = "favorite"
            :status   = "status"
            class     = "mt-2"
        />
    </div>
</div>
